import { observer } from 'mobx-react';
import { Component } from 'react';
import { DeliveryZoneMapControls } from '../../components/DeliveryZoneMapControls/DeliveryZoneMapControls';
import deliveryZonesStore from '../../stores/deliveryZonesStore';
import DeiveryZoneDrawingTools from '../DeiveryZoneDrawingTools/DeiveryZoneDrawingTools';
import DeliveryZonesDraftAreas from '../DeliveryZonesDraftAreas/DeliveryZonesDraftAreas';
import DeliveryZonesMapAreas from '../DeliveryZonesMapAreas/DeliveryZonesMapAreas';
import DeliveryZonesMapBranches from '../DeliveryZonesMapBranches/DeliveryZonesMapBranches';
import DeliveryZoneTooltip from '../DeliveryZoneTooltip/DeliveryZoneTooltip';
import askAgain, { AskAgainKey } from '~/services/askAgain';
import Map from 'src/view/components/Map/Map/Map';
import { HintModal } from 'src/view/components/HintModal/HintModal';
import './style.scss';

@observer
export default class DeliveryZonesMapContainer extends Component {
  drawHintModal = (checkboxStatus?: boolean) => {
    if (checkboxStatus) askAgain.changeHintMessageSetting(AskAgainKey.DRAW_POLYGON);
    deliveryZonesStore.changeDrawHintVisibility(false);
  };

  branchNotCoveredHintModal = () => {
    deliveryZonesStore.editDraftZone('bounds', []);
    // deliveryZonesStore.changeBranchNotCoveredHintVisibility(false);
    if (deliveryZonesStore.draft) deliveryZonesStore.selectZone(deliveryZonesStore.draft);
  };

  render() {
    return (
      <div className="delivery-zone-map">
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Map mapRef={deliveryZonesStore.mapStore.ref} {...deliveryZonesStore.mapStore.props}>
          <DeliveryZonesMapAreas />
          <DeliveryZonesDraftAreas />
          <DeiveryZoneDrawingTools />
          <DeliveryZonesMapBranches />
          <DeliveryZoneTooltip />
          <HintModal
            visible={deliveryZonesStore.showDrawHint}
            text="draw_area"
            checkbox
            checkBoxLabel="dont_show_again"
            submit={this.drawHintModal}
          />
          {/* <HintModal visible={deliveryZonesStore.showBranchNotCoveredHint}
          text="branch_not_covered" submit={this.branchNotCoveredHintModal} /> */}
        </Map>
        <DeliveryZoneMapControls />
      </div>
    );
  }
}
